<template lang="pug">
  multiselect(
    class="multiselect-select"
    v-model="value",
    :options="tags",
    :searchable="false",
    :show-labels="false"
    :placeholder="placeholder"
    :multiple="multiple"
    label="label"
    track-by="value"
    open-direction="bottom"
    @select="handleSelect"
    :allow-empty="false"
  )
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },

  props: {
    tags: {
      type: Array,
      default: () => {
        return []
      }
    },

    selected_tag: {
      type: Object,
      default: () => ({})
    },

    multiple: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: 'Sélectionner un motif de consultation'
    }
  },

  data () {
    if (Object.keys(this.selected_tag).length === 0) {
      return {
        value: null
      }
    } else {
      return {
        value: this.selected_tag
      }
    }
  },

  methods: {
    handleSelect (selectedOption) {
      this.$emit('change', selectedOption)
    }
  }
}
</script>
